<template>
	<rmp-master-account-access-application-base-step v-if="initialized" :title="tc('titles.enterContactInformation')">
		<v-form v-model="formValid" ref="form" :readonly="readonly || masterAccountAccessStore.createMasterAccountRequestOperationExecuting">
			<v-container class="pa-0">
				<v-row no-gutters>
					<v-col cols="12">
						<rmp-text tag="span" type="body-large" :color="colors.grey.darken1">
							{{ tc("common.masterAccountAccessContactInformationStep.stepTwo") }}
						</rmp-text>
					</v-col>
					<v-col cols="12" class="mt-6">
						<rmp-text-field v-model="email"
										name="email"
										@keydown.enter.prevent
										autocomplete="email"
										data-cy="email"
										:rules="validation.email"
										type="email"
										:placeholder="tc('fields.simpleEmail.placeholder')">
						</rmp-text-field>
					</v-col>
					<v-col cols="12" class="mt-2">
						<rmp-text tag="span" type="body-large" :color="colors.grey.darken1">
							{{ tc("common.masterAccountAccessContactInformationStep.subtitleTwo") }}
						</rmp-text>
					</v-col>
				</v-row>
			</v-container>
		</v-form>
	</rmp-master-account-access-application-base-step>
</template>

<script setup lang="ts">
import RmpText from "@rmp/core/components/typography/RmpText.vue";
import RmpTextField from "@rmp/core/components/fields/RmpTextField.vue";
import { prepareEmailRule, prepareInnRule, requiredRule } from "@rmp/core/utils/validation";
import RmpMasterAccountAccessApplicationBaseStep
	from "@rmp/id/views/masterAccountAccess/steps/RmpMasterAccountAccessApplicationBaseStep.vue";
import { useColors } from "@rmp/core/composables/useColors";
import { useI18n } from "vue-i18n-composable";
import { useMasterAccountAccessSelectCounterpartyStepStore } from "@rmp/id/stores/masterAccountAccess/steps/selectCounterparty";
import { useMasterAccountAccessContactInformationStepStore } from "@rmp/id/stores/masterAccountAccess/steps/contactInformation";
import { storeToRefs } from "pinia";
import { ref, watch } from "vue";
import { usePage } from "@rmp/core/composables/usePage";
import { useMasterAccountAccessStore } from "@rmp/id/stores/masterAccountAccess";

export interface Props {
	readonly?: boolean;
}

defineProps<Props>();

const { colors } = useColors();

const { tc } = useI18n();

const useStore = useMasterAccountAccessContactInformationStepStore;
const masterAccountAccessStore = useMasterAccountAccessStore();
const store = useStore();

let {
	email,
	formValid
} = storeToRefs(store);

const {} = useStore();

const form = ref<any>(null);

const validation = {
	email: [requiredRule(), prepareEmailRule()]
};

watch(email, async (value) => {
	if(value)
		form.value.validate();
});

const { initialized } = usePage({ useStore });
</script>
